import { Conflicts as AvailConflicts, ObjectConflict, RsConflict, SpConflict } from "../../services/space.service";
import { PickByType } from "../../pojo/Util";

export namespace AcademicGridAvailability {
    export type Conflicts = { locations: GroupedConflict[]; resources: GroupedConflict[] };
    /**
     * Group conflicts by source profile, target profile, and object id
     */
    export function extractConflicts(conflicts: AvailConflicts) {
        return {
            locations: groupConflicts(conflicts.spConflicts, "roomId"),
            resources: groupConflicts(conflicts.rsConflicts, "resourceId"),
        };
    }

    type GroupedConflict = Pick<
        ObjectConflict,
        | "conflictType"
        | "relnType"
        | "candidateEventId"
        | "candidateEvDtProfileId"
        | "conflictEventId"
        | "conflictEvDtProfileId"
    > & { objectId: number };
    function groupConflicts<T extends SpConflict | RsConflict>(
        conflicts: T[] | undefined,
        objIdKey: keyof PickByType<T, number>,
    ): GroupedConflict[] {
        const seen = new Set<string>();
        const grouped: GroupedConflict[] = [];
        for (const conflict of conflicts ?? []) {
            const key = `${conflict.candidateEvDtProfileId}-${conflict.conflictEvDtProfileId}-${conflict[objIdKey]}`;
            if (seen.has(key)) continue;
            seen.add(key);
            grouped.push({
                conflictType: conflict.conflictType,
                relnType: conflict.relnType,
                candidateEventId: conflict.candidateEventId,
                candidateEvDtProfileId: conflict.candidateEvDtProfileId,
                conflictEventId: conflict.conflictEventId,
                conflictEvDtProfileId: conflict.conflictEvDtProfileId,
                objectId: <number>conflict[objIdKey],
            });
        }

        return grouped;
    }
}
